










import { Component, Prop, Vue, Mixins } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import Tabs from './Tabs.vue'
const authMap = {
	statistics: {
		key: '1',
		title: '数据信息',
		authStr: 'visitorDetail:statistics',
	},
	basicInfo: {
		key: '2',
		title: '基本信息',
		authStr: 'visitorDetail:basicInfo',
	},
}

@Component({
	name: 'partnerVisitorDetail',
	components: {
		PageLayout,
		Tabs,
	},
})
export default class UsersList extends Vue {
	private data: any[] = []
	private action: any = {}
	private commentVisible: boolean = false
	private tabs: any = {
		index: authMap.statistics.key,
		items: [
			// 默认值 避免详情计算margin缺少tabs高度
			authMap.statistics,
		],
		active: () => {
			return this.tabs.index
		},
		callback: (key: any) => {
			this.tabs.index = key
		},
	}

	private activated() {
		let items = [authMap.statistics, authMap.basicInfo]
		items = items.filter((item: any) => this.$auth(item.authStr))
		this.$set(this.tabs, 'items', items)
		this.tabs.index = items[0] && items[0].key
	}

	private back() {
		this.$router.go(-1)
	}
}
